<div class='px-1'>
  <div class='UserContactsListingMobileRow mobile-row row px-3'>
    <div class='mobile-row-section col col-5 d-flex flex-column align-items-start'>
      <div>{{ contactName }}</div>
      <div>{{ item.group_name }}</div>
    </div>
    <div class='mobile-row-section col col-5 d-flex flex-column align-items-start'>
      <div>{{ item.email_position }}</div>
      <div>{{ item.contact_status }}</div>
    </div>
    <div class='mobile-row-section col col-2'>
      <app-menu-button [properties]='menuItems'
                       [target]='item'></app-menu-button>
    </div>
  </div>
</div>